import React from 'react';
import { Button } from '@mui/material';
import { mvkgTokens } from '../../theme/mvkgTokens';

/**
 * Thin wrapper over MUI Button enforcing the prototype's button vocabulary:
 * primary (brand gradient), secondary (glass white), ghost, danger.
 */
const VARIANT_SX = {
  primary: {
    background: mvkgTokens.gradient.brand,
    color: '#fff',
    boxShadow: mvkgTokens.shadow.brandSm,
    '&:hover': { background: mvkgTokens.gradient.brand, filter: 'brightness(1.05)', boxShadow: mvkgTokens.shadow.brand },
    // MUI's disabled text (rgba(0,0,0,.26)) over the brand gradient failed
    // contrast. Disabled is a slate wash with slate ink instead (7:1).
    '&.Mui-disabled': { background: 'rgba(100,116,139,0.14)', color: '#475569', boxShadow: 'none' },
  },
  secondary: {
    bgcolor: 'rgba(255,255,255,0.8)',
    color: 'text.primary',
    border: `1px solid ${mvkgTokens.surface.glassBorderStrong}`,
    '&:hover': { bgcolor: '#fff' },
  },
  ghost: {
    color: 'text.secondary',
    '&:hover': { color: 'primary.main', bgcolor: mvkgTokens.surface.glassSoft },
  },
  danger: {
    // #dc2626 on white ink is 4.8:1; the palette's error.main (#ef4444) was
    // 3.8:1 and failed on every danger button in the admin.
    bgcolor: '#dc2626',
    color: '#fff',
    '&:hover': { bgcolor: '#b91c1c' },
  },
};

const SIZE_SX = {
  sm: { height: 36, px: 2, fontSize: '0.75rem' },
  md: { height: 44, px: 2.5, fontSize: '0.875rem' },
  lg: { height: 48, px: 3, fontSize: '1rem' },
};

export default function AppButton({
  variant = 'primary',
  size = 'md',
  startIcon,
  endIcon,
  children,
  sx = {},
  ...rest
}) {
  return (
    <Button
      disableElevation
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        textTransform: 'none',
        fontWeight: 700,
        borderRadius: `${mvkgTokens.radius.md}px`,
        transition: 'all 0.15s ease',
        '&:active': { transform: 'scale(0.98)' },
        ...SIZE_SX[size],
        ...VARIANT_SX[variant],
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}
